import { render, staticRenderFns } from "./DependencyPicker.vue?vue&type=template&id=64271b2b&scoped=true&"
import script from "./DependencyPicker.vue?vue&type=script&lang=js&"
export * from "./DependencyPicker.vue?vue&type=script&lang=js&"
import style0 from "./DependencyPicker.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DependencyPicker.vue?vue&type=style&index=1&id=64271b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64271b2b",
  null
  
)

export default component.exports